import { z } from 'zod';

// Login request schema
export const loginRequestSchema = z.object({
    email: z.string().email('Invalid email format').min(1, 'Email is required'),
    password: z.string().min(6, 'Password must be at least 6 characters long'),
});

// Register request schema - matches backend expectations
export const registerRequestSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email format'),
    password: z.string()
        .min(8, 'Password must be at least 8 characters long')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number'),
});

// Alternative register schema with combined name (for simpler forms)
export const registerSimpleSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    email: z.string().email('Invalid email format'),
    password: z.string().min(8, 'Password must be at least 8 characters long'),
});

// Auth response schema
export const authResponseSchema = z.object({
    statusCode: z.number(),
    data: z.object({
        message: z.string(),
        token: z.string().min(1, 'Token is required'),
        user: z.object({
            id: z.string(),
            email: z.string(),
            firstName: z.string(),
            lastName: z.string(),
            role: z.enum(['PARENT', 'ADMIN']),
        }).optional(),
    }),
});

// Export types
export type LoginRequest = z.infer<typeof loginRequestSchema>;
export type RegisterRequest = z.infer<typeof registerRequestSchema>;
export type RegisterFullRequest = z.infer<typeof registerRequestSchema>;
export type RegisterSimpleRequest = z.infer<typeof registerSimpleSchema>;
export type AuthResponse = z.infer<typeof authResponseSchema>;